/* Geneva project list: products saved in the browser, sent as one enquiry. */
(function () {
  var KEY = 'gv_project_v1';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} render(); }
  function find(list, h) { for (var i = 0; i < list.length; i++) if (list[i].h === h) return i; return -1; }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function toggle(btn) {
    var d = btn.dataset, list = read();
    if (d.gvMode === 'add') {
      var key = d.handle + (d.variant ? '::' + d.variant : ''), q = 1;
      if (d.qtyFrom) { var el = document.querySelector(d.qtyFrom); q = Math.max(1, parseInt(el && el.value, 10) || 1); }
      var k = find(list, key);
      if (k > -1) list[k].q += q;
      else list.push({ h: key, t: d.title + (d.variant ? ' \u2014 ' + d.variant : ''), v: d.vendor || '', i: d.image || '', u: d.url + (d.variantId ? '?variant=' + d.variantId : ''), q: q });
      write(list);
      btn.classList.add('is-flash');
      var lab = btn.querySelector('[data-gv-add-label]'); if (lab) lab.textContent = 'Added to project';
      var note = document.querySelector('[data-gv-added]'); if (note) note.hidden = false;
      setTimeout(function () { btn.classList.remove('is-flash'); render(); }, 1800);
      return;
    }
    var i = find(list, d.handle);
    if (i > -1) list.splice(i, 1);
    else list.push({ h: d.handle, t: d.title, v: d.vendor || '', i: d.image || '', u: d.url, q: 1 });
    write(list);
  }
  function has(list, handle) { for (var i = 0; i < list.length; i++) if (list[i].h === handle || list[i].h.indexOf(handle + '::') === 0) return true; return false; }

  function render() {
    var list = read(), total = 0;
    list.forEach(function (x) { total += x.q; });
    document.querySelectorAll('[data-gv-count]').forEach(function (el) {
      el.textContent = list.length; el.parentElement.classList.toggle('has-items', list.length > 0);
    });
    document.querySelectorAll('[data-gv-add]').forEach(function (btn) {
      if (btn.dataset.gvMode === 'add') {
        if (btn.classList.contains('is-flash')) return;
        var inList = has(list, btn.dataset.handle), l = btn.querySelector('[data-gv-add-label]');
        if (l) l.textContent = inList ? 'Add more to project' : 'Add to project';
        return;
      }
      var added = find(list, btn.dataset.handle) > -1;
      btn.classList.toggle('is-added', added);
      btn.setAttribute('aria-pressed', added);
      var label = btn.querySelector('[data-gv-add-label]');
      if (label) label.textContent = added ? 'In project list' : 'Add to project';
    });
    document.querySelectorAll('[data-gv-project-list]').forEach(function (wrap) {
      var rows = wrap.querySelector('[data-gv-rows]'), empty = wrap.querySelector('[data-gv-empty]'), form = wrap.querySelector('[data-gv-form]');
      wrap.classList.toggle('is-empty', list.length === 0);
      if (empty) empty.hidden = list.length > 0;
      if (form) form.hidden = list.length === 0;
      var sum = wrap.querySelector('[data-gv-summary]');
      if (sum) sum.textContent = list.length + (list.length === 1 ? ' product' : ' products') + ' \u00b7 ' + total + (total === 1 ? ' unit' : ' units');
      if (!rows) return;
      rows.innerHTML = list.map(function (x, n) {
        return '<li class="gv-plist__row">' +
          '<span class="gv-plist__n">' + String(n + 1).padStart(2, '0') + '</span>' +
          '<a class="gv-plist__img" href="' + esc(x.u) + '">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="gv-plist__info">' + (x.v ? '<span class="gv-label">' + esc(x.v) + '</span>' : '') + '<a href="' + esc(x.u) + '">' + esc(x.t) + '</a></div>' +
          '<div class="gv-qty"><button type="button" data-gv-qty="-1" data-h="' + esc(x.h) + '" aria-label="Decrease">\u2212</button><input type="number" min="1" value="' + x.q + '" data-gv-qty-input data-h="' + esc(x.h) + '" aria-label="Quantity"><button type="button" data-gv-qty="1" data-h="' + esc(x.h) + '" aria-label="Increase">+</button></div>' +
          '<button type="button" class="gv-plist__remove" data-gv-remove="' + esc(x.h) + '">Remove</button>' +
          '</li>';
      }).join('');
      var field = wrap.querySelector('[data-gv-field]');
      if (field) field.value = list.map(function (x, n) { return (n + 1) + '. ' + x.t + (x.v ? ' (' + x.v + ')' : '') + ' x ' + x.q + ' - ' + location.origin + x.u; }).join('\n');
    });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-gv-add]');
    if (add) { e.preventDefault(); toggle(add); return; }
    var q = e.target.closest('[data-gv-qty]');
    if (q) { var l = read(), i = find(l, q.dataset.h); if (i > -1) { l[i].q = Math.max(1, l[i].q + parseInt(q.dataset.gvQty, 10)); write(l); } return; }
    var r = e.target.closest('[data-gv-remove]');
    if (r) { var l2 = read(), j = find(l2, r.dataset.gvRemove); if (j > -1) { l2.splice(j, 1); write(l2); } }
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-gv-qty-input]')) return;
    var l = read(), i = find(l, e.target.dataset.h);
    if (i > -1) { l[i].q = Math.max(1, parseInt(e.target.value, 10) || 1); write(l); }
  });
  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-gv-form] form, form[data-gv-form]')) return;
    render();
  }, true);

  try {
    var enq = new URLSearchParams(location.search).get('enquiry');
    if (enq) document.addEventListener('DOMContentLoaded', function () {
      var ta = document.querySelector('textarea[name="contact[body]"]');
      if (ta && !ta.value) ta.value = enq + '\n\n';
      var sel = document.querySelector('select[name="contact[regarding]"]');
      if (sel) { for (var o = 0; o < sel.options.length; o++) if (/quote|product|showroom/i.test(sel.options[o].text) && enq.toLowerCase().indexOf(sel.options[o].text.toLowerCase().split(' ')[0]) > -1) sel.selectedIndex = o; }
    });
  } catch (e) {}
  if (document.querySelector('[data-gv-sent]')) { try { localStorage.removeItem(KEY); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render); else render();
  document.addEventListener('shopify:section:load', render);
  document.addEventListener('facet:update', render);
  new MutationObserver(function (m) {
    for (var k = 0; k < m.length; k++) for (var n = 0; n < m[k].addedNodes.length; n++) {
      var node = m[k].addedNodes[n];
      if (node.nodeType === 1 && (node.matches('[data-gv-add]') || node.querySelector('[data-gv-add]'))) { render(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
